var map = {
	"./color01_press.png": 12949,
	"./color02_press.png": 23127,
	"./color03_press.png": 12274,
	"./color04_press.png": 95892,
	"./color05_press.png": 75511,
	"./color06_press.png": 96597,
	"./color07_press.png": 80964,
	"./color08_press.png": 47809,
	"./color09_press.png": 58180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60450;